import $ from 'jquery';
import {path} from 'ramda';

let _api, paymentsClient, configuration, elements;

function tokenizationSpecification()
{
    return  {
        type: 'PAYMENT_GATEWAY',
        parameters: {
            'gateway': configuration.gateway,
            'gatewayMerchantId': configuration.gatewayMerchantId
        }
    };
}

function baseRequest()
{
    let apiVersion, apiVersionMinor;
    [apiVersion, apiVersionMinor] = configuration.apiVersion.split('.').map(val => parseInt(val));

    return { apiVersion, apiVersionMinor };
}

function merchantInfo()
{
    return {
        merchantInfo: {
            merchantName: configuration.merchantName,
            merchantId: configuration.merchantId
        }
    };
}

function baseCardPaymentMethod()
{
    return {
        type: 'CARD',
        parameters: {
            allowedAuthMethods: configuration.allowedCardAuthMethods,
            allowedCardNetworks: configuration.allowedCardNetworks
        }
    };
}

function isReadyToPayRequest()
{
    return Object.assign(
        {},
        baseRequest(),
        {
            allowedPaymentMethods: [baseCardPaymentMethod()]
        }
    );
}

function paymentDataRequest(transactionInfo)
{
    return Object.assign(
        {},
        {
            allowedPaymentMethods: [Object.assign(
                {},
                {
                    tokenizationSpecification: tokenizationSpecification()
                },
                baseCardPaymentMethod()
            )]
        },
        baseRequest(),
        merchantInfo(),
        {transactionInfo}
    );
}

function apiNotFound()
{
    throw new Error('Google Payments API not found!');
}

function createPayButton(onClick)
{
    return client().createButton({
        buttonColor: 'white',
        buttonType: 'buy',
        buttonLocale: 'cs',
        onClick
    });
}

function api(safe = false)
{
    if (!_api && path(['google', 'payments', 'api'], window)) {
        _api = google.payments.api;
    }

    if (!safe && !_api) {
        apiNotFound();
    }

    return _api;
}

function pay(result)
{
    if (result.status && result.transactionInfo && result.links && result.modal) {
        const modal = $(result.modal);
        elements.modals.append(modal);
        modal.addClass('modal--active');
        modal.find('.google-pay-buttons').prepend(createPayButton(() => {
            client().loadPaymentData(paymentDataRequest(result.transactionInfo)).then(paymentData => {
                if (paymentData) {
                    let payUrl = new URL(result.links.pay);
                    $.post(
                        payUrl,
                        { google_pay_payment_data: paymentData.paymentMethodData.tokenizationData.token }
                    ).then((response, status, xhr) => {
                        const location = response.location || xhr.getResponseHeader('Location');
                        if (location) {
                            window.location.href = location;
                        } else {
                            console.error('No Location header sent!');
                        }
                    });
                } else {
                    window.location.href = result.links.failure;
                }
            });
        }));
    }
}

export function client()
{
    if (!paymentsClient) {
        paymentsClient = new _api.PaymentsClient({ environment: configuration.environment });
    }

    return paymentsClient;
}

export function checkReadiness()
{
    return client().isReadyToPay(isReadyToPayRequest());
}

export function isSupported() {
    return api(true) && window.isSecureContext
        ? new Promise(resolve => {
            checkReadiness()
                .then(response => {
                    resolve(!!response.result);
                })
                .catch(error => {
                    console.log(error);
                    resolve(false);
                });
        })
        : new Promise(resolve => resolve(false));
}

export function initializeGooglePay(_elements, _configuration, deferred)
{
    elements = _elements;
    configuration = _configuration

    isSupported().then(result => {
        if (result) {
            if (elements.paymentMethodChoice) {
                $(elements.paymentMethodChoice).show();
            }
            if (elements.triggerButton && elements.triggerButton.hasClass('disabled')) {
                elements.triggerButton.removeClass('disabled');
            }
            deferred.then(pay);
        }
    }).catch(error => console.log(error));
}
